import * as actions from "./actions";
import mutations from "./mutations";
import getters from "./getters";
import state from "./state";
import _cloneDeep from "lodash/cloneDeep";

export default {
  namespaced: true,
  state: _cloneDeep(state),
  actions,
  mutations,
  getters
};
